import { gql } from "@apollo/client";

export const PERFORMANCE = gql`
query performance($pageNo:Int, $pageSize:Int!, $performanceFilterInput:PerformanceFilterInput!){
    performance(pageNo:$pageNo, pageSize: $pageSize, performanceFilterInput:$performanceFilterInput){
        count,
        performanceList{
            userId,
            userName,
            country,
            firstDepositDate,
            registerDate,
            currencyId,
            firstDepositAmount,
            totalDeposit,
            totalWithdrawal,
            totalProcessingFee,
            totalBonus,
            totalVipBonus,
            profit,
            betCount,
            totalTurnover
        }
    }
}
`

export const GET_PERFORMANCE_EXPORT = gql`
query PerformanceExport($performanceFilterInput: PerformanceFilterInput!){
    performanceExport(performanceFilterInput: $performanceFilterInput){
        status,
        csv
    }
}
`;